import { c as _c } from "react/compiler-runtime";
import { Avatar, Badge, Box, Button, Card, HStack, IconButton, Separator, Text, VStack } from '@chakra-ui/react';
import { MenuContent, MenuItem, MenuItemGroup, MenuRoot, MenuSeparator, MenuTrigger } from '@src/components/chakra-ui/menu';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AGREEMENT_STATUS_DECLINED, AGREEMENT_STATUS_DRAFT, AGREEMENT_STATUS_SENT, AGREEMENT_STATUS_SIGNED, agreementStatusTitle } from '@src/components/sco/Advisors/utils/agreementKeys';
import { agreementHasMenu, agreementMenuGroups, agreementPrimaryAction, agreementSecondaryAction, type AgreementListItem, type AgreementMenuActionKind } from '@src/components/sco/Advisors/utils/agreementList';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import { LuDownload, LuEllipsis, LuFileText, LuRefreshCw, LuSquarePen, LuTrash2, LuX } from 'react-icons/lu';
export type { AgreementListItem };
const statusBadge = (statusKey: string, statusTitle?: string) => {
  if (statusKey === AGREEMENT_STATUS_SIGNED) {
    return {
      label: agreementStatusTitle(statusKey, statusTitle),
      colorPalette: 'green' as const
    };
  }
  if (statusKey === AGREEMENT_STATUS_SENT) {
    return {
      label: agreementStatusTitle(statusKey, statusTitle),
      colorPalette: 'yellow' as const
    };
  }
  if (statusKey === AGREEMENT_STATUS_DRAFT) {
    return {
      label: agreementStatusTitle(statusKey, statusTitle),
      colorPalette: 'purple' as const
    };
  }
  if (statusKey === AGREEMENT_STATUS_DECLINED) {
    return {
      label: agreementStatusTitle(statusKey, statusTitle),
      colorPalette: 'red' as const
    };
  }
  return {
    label: agreementStatusTitle(statusKey, statusTitle),
    colorPalette: 'gray' as const
  };
};
const MENU_ICONS: Partial<Record<AgreementMenuActionKind, typeof LuDownload>> = {
  pdf: LuDownload,
  checkStatus: LuRefreshCw,
  requestChanges: LuSquarePen,
  decline: LuX,
  delete: LuTrash2
};
export const AgreementListRow = t0 => {
  const $ = _c(128);
  const {
    row,
    showPartyBadge,
    signHref,
    onDownloadPdf,
    downloading,
    onCheckStatus,
    checkingStatus,
    onRespond,
    respondLoading,
    onDelete,
    deleting
  } = t0;
  const paths = useAdvisorsPaths();
  const router = useRouter();
  let t1;
  if ($[0] !== row.statusKey || $[1] !== row.statusTitle) {
    t1 = statusBadge(row.statusKey, row.statusTitle);
    $[0] = row.statusKey;
    $[1] = row.statusTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const badge = t1;
  let t2;
  if ($[3] !== paths || $[4] !== row.advisorAgreementId) {
    t2 = paths.agreementEdit(row.advisorAgreementId);
    $[3] = paths;
    $[4] = row.advisorAgreementId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const viewHref = t2;
  const signUrl = signHref ? `${signHref}?agreementId=${encodeURIComponent(row.advisorAgreementId)}` : `${paths.sign}?agreementId=${encodeURIComponent(row.advisorAgreementId)}`;
  let t3;
  if ($[6] !== row) {
    t3 = agreementPrimaryAction(row);
    $[6] = row;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const primary = t3;
  let t4;
  if ($[8] !== row) {
    t4 = agreementSecondaryAction(row);
    $[8] = row;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const secondary = t4;
  let T0;
  let T1;
  let T2;
  let primaryHref;
  let primaryIsLink;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[10] !== badge.colorPalette || $[11] !== badge.label || $[12] !== checkingStatus || $[13] !== deleting || $[14] !== downloading || $[15] !== onCheckStatus || $[16] !== onDelete || $[17] !== onDownloadPdf || $[18] !== onRespond || $[19] !== primary.kind || $[20] !== respondLoading || $[21] !== router || $[22] !== row || $[23] !== showPartyBadge || $[24] !== signUrl || $[25] !== viewHref) {
    const menuGroups = agreementMenuGroups(row);
    const showMenu = agreementHasMenu(row);
    const busy = downloading || checkingStatus || respondLoading || deleting;
    const stop = _temp;
    let t18;
    if ($[44] !== onCheckStatus || $[45] !== onDelete || $[46] !== onDownloadPdf || $[47] !== onRespond || $[48] !== row.advisorAgreementId) {
      t18 = kind => {
        if (kind === "pdf") {
          onDownloadPdf?.(row.advisorAgreementId);
          return;
        }
        if (kind === "checkStatus") {
          onCheckStatus?.(row.advisorAgreementId);
          return;
        }
        if (kind === "requestChanges") {
          onRespond?.(row.advisorAgreementId, "REQUEST_CHANGES");
          return;
        }
        if (kind === "decline") {
          onRespond?.(row.advisorAgreementId, "DECLINE");
          return;
        }
        if (kind === "delete") {
          onDelete?.(row.advisorAgreementId);
        }
      };
      $[44] = onCheckStatus;
      $[45] = onDelete;
      $[46] = onDownloadPdf;
      $[47] = onRespond;
      $[48] = row.advisorAgreementId;
      $[49] = t18;
    } else {
      t18 = $[49];
    }
    const runMenuAction = t18;
    primaryIsLink = primary.kind === "sign" || primary.kind === "edit" || primary.kind === "view";
    primaryHref = primary.kind === "sign" ? signUrl : viewHref;
    T2 = Card.Root;
    t15 = "sm";
    t16 = "interactive";
    if ($[50] !== router || $[51] !== viewHref) {
      t17 = () => router.push(viewHref);
      $[50] = router;
      $[51] = viewHref;
      $[52] = t17;
    } else {
      t17 = $[52];
    }
    T1 = Card.Body;
    t12 = 4;
    let t19;
    if ($[53] !== row.name || $[54] !== row.pictureUrl) {
      t19 = row.pictureUrl ? <Avatar.Image alt={row.name} src={row.pictureUrl} /> : null;
      $[53] = row.name;
      $[54] = row.pictureUrl;
      $[55] = t19;
    } else {
      t19 = $[55];
    }
    let t20;
    if ($[56] !== row.name) {
      t20 = <Avatar.Fallback name={row.name} />;
      $[56] = row.name;
      $[57] = t20;
    } else {
      t20 = $[57];
    }
    let t21;
    if ($[58] !== row.palette || $[59] !== t19 || $[60] !== t20) {
      t21 = <Avatar.Root colorPalette={row.palette} flexShrink={0} size="lg">{t19}{t20}</Avatar.Root>;
      $[58] = row.palette;
      $[59] = t19;
      $[60] = t20;
      $[61] = t21;
    } else {
      t21 = $[61];
    }
    let t22;
    if ($[62] !== row.name) {
      t22 = <Text fontWeight="semibold" lineClamp={1}>{row.name}</Text>;
      $[62] = row.name;
      $[63] = t22;
    } else {
      t22 = $[63];
    }
    let t23;
    if ($[64] !== row.partyRole || $[65] !== showPartyBadge) {
      t23 = showPartyBadge ? <Badge variant="outline">{row.partyRole === "ADVISOR" ? "Received" : "Sent"}</Badge> : null;
      $[64] = row.partyRole;
      $[65] = showPartyBadge;
      $[66] = t23;
    } else {
      t23 = $[66];
    }
    let t24;
    if ($[67] !== badge.colorPalette || $[68] !== badge.label) {
      t24 = <Badge colorPalette={badge.colorPalette} variant="subtle">{badge.label}</Badge>;
      $[67] = badge.colorPalette;
      $[68] = badge.label;
      $[69] = t24;
    } else {
      t24 = $[69];
    }
    let t25;
    if ($[70] !== t23 || $[71] !== t24) {
      t25 = <HStack flexShrink={0} gap={1} justify="flex-end" wrap="wrap">{t23}{t24}</HStack>;
      $[70] = t23;
      $[71] = t24;
      $[72] = t25;
    } else {
      t25 = $[72];
    }
    let t26;
    if ($[73] !== t22 || $[74] !== t25) {
      t26 = <HStack align="start" gap={2} justify="space-between" width="full">{t22}{t25}</HStack>;
      $[73] = t22;
      $[74] = t25;
      $[75] = t26;
    } else {
      t26 = $[75];
    }
    let t27;
    if ($[76] !== row.sub) {
      t27 = <Text color="colorPalette.fg/60" fontSize="xs" lineClamp={1}>{row.sub}</Text>;
      $[76] = row.sub;
      $[77] = t27;
    } else {
      t27 = $[77];
    }
    let t28;
    if ($[78] !== row.signersLine) {
      t28 = row.signersLine ? <Text color="colorPalette.fg/55" fontSize="xs" lineClamp={1}>{row.signersLine}</Text> : null;
      $[78] = row.signersLine;
      $[79] = t28;
    } else {
      t28 = $[79];
    }
    let t29;
    if ($[80] !== row.date || $[81] !== row.version) {
      t29 = <Text color="colorPalette.fg/40" fontSize="2xs" lineClamp={1}>{row.version} · {row.date}</Text>;
      $[80] = row.date;
      $[81] = row.version;
      $[82] = t29;
    } else {
      t29 = $[82];
    }
    let t30;
    if ($[83] !== t26 || $[84] !== t27 || $[85] !== t28 || $[86] !== t29) {
      t30 = <VStack align="stretch" flex={1} gap={0.5} minWidth={0}>{t26}{t27}{t28}{t29}</VStack>;
      $[83] = t26;
      $[84] = t27;
      $[85] = t28;
      $[86] = t29;
      $[87] = t30;
    } else {
      t30 = $[87];
    }
    if ($[88] !== t21 || $[89] !== t30) {
      t13 = <HStack align="start" gap={3} minWidth={0}>{t21}{t30}</HStack>;
      $[88] = t21;
      $[89] = t30;
      $[90] = t13;
    } else {
      t13 = $[90];
    }
    if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Separator />;
      $[91] = t14;
    } else {
      t14 = $[91];
    }
    T0 = HStack;
    t5 = "center";
    t6 = "nowrap";
    t7 = 2;
    t8 = "flex-end";
    t9 = "full";
    t10 = stop;
    t11 = showMenu ? <Box onClick={stop}><MenuRoot positioning={{
        placement: "bottom-end"
      }}><MenuTrigger asChild={true}><IconButton aria-label={`More actions for ${row.name}`} loading={busy} size="xs" variant="ghost" onClick={stop}><LuEllipsis /></IconButton></MenuTrigger><MenuContent minW="12rem">{menuGroups.map((group, groupIndex) => <Fragment key={group.key}>{groupIndex > 0 ? <MenuSeparator /> : null}<MenuItemGroup title={group.label}>{group.items.map(item => {
                const Icon = MENU_ICONS[item.kind];
                const isDanger = item.kind === "delete" || item.kind === "decline";
                return <MenuItem key={item.kind} color={isDanger ? "fg.error" : undefined} value={item.kind} onClick={() => runMenuAction(item.kind)}>{Icon ? <Icon /> : null}{item.label}</MenuItem>;
              })}</MenuItemGroup></Fragment>)}</MenuContent></MenuRoot></Box> : null;
    $[10] = badge.colorPalette;
    $[11] = badge.label;
    $[12] = checkingStatus;
    $[13] = deleting;
    $[14] = downloading;
    $[15] = onCheckStatus;
    $[16] = onDelete;
    $[17] = onDownloadPdf;
    $[18] = onRespond;
    $[19] = primary.kind;
    $[20] = respondLoading;
    $[21] = router;
    $[22] = row;
    $[23] = showPartyBadge;
    $[24] = signUrl;
    $[25] = viewHref;
    $[26] = T0;
    $[27] = T1;
    $[28] = T2;
    $[29] = primaryHref;
    $[30] = primaryIsLink;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
  } else {
    T0 = $[26];
    T1 = $[27];
    T2 = $[28];
    primaryHref = $[29];
    primaryIsLink = $[30];
    t10 = $[31];
    t11 = $[32];
    t12 = $[33];
    t13 = $[34];
    t14 = $[35];
    t15 = $[36];
    t16 = $[37];
    t17 = $[38];
    t5 = $[39];
    t6 = $[40];
    t7 = $[41];
    t8 = $[42];
    t9 = $[43];
  }
  let t18;
  if ($[92] !== downloading || $[93] !== onDownloadPdf || $[94] !== row.advisorAgreementId || $[95] !== secondary) {
    t18 = secondary?.kind === "pdf" ? <Button loading={!!downloading} size="xs" variant="outline" onClick={() => onDownloadPdf?.(row.advisorAgreementId)}><LuDownload />{secondary.label}</Button> : null;
    $[92] = downloading;
    $[93] = onDownloadPdf;
    $[94] = row.advisorAgreementId;
    $[95] = secondary;
    $[96] = t18;
  } else {
    t18 = $[96];
  }
  let t19;
  if ($[97] !== downloading || $[98] !== onDownloadPdf || $[99] !== primary.kind || $[100] !== primary.label || $[101] !== primaryHref || $[102] !== primaryIsLink || $[103] !== row.advisorAgreementId) {
    t19 = primaryIsLink ? <Button asChild={true} size="xs" variant="cta"><NextLink href={primaryHref}>{primary.kind === "sign" ? null : <LuFileText />}{primary.label}</NextLink></Button> : <Button loading={!!downloading} size="xs" variant="cta" onClick={() => onDownloadPdf?.(row.advisorAgreementId)}><LuDownload />{primary.label}</Button>;
    $[97] = downloading;
    $[98] = onDownloadPdf;
    $[99] = primary.kind;
    $[100] = primary.label;
    $[101] = primaryHref;
    $[102] = primaryIsLink;
    $[103] = row.advisorAgreementId;
    $[104] = t19;
  } else {
    t19 = $[104];
  }
  let t20;
  if ($[105] !== T0 || $[106] !== t10 || $[107] !== t11 || $[108] !== t18 || $[109] !== t19 || $[110] !== t5 || $[111] !== t6 || $[112] !== t7 || $[113] !== t8 || $[114] !== t9) {
    t20 = <T0 align={t5} flexWrap={t6} gap={t7} justify={t8} width={t9} onClick={t10}>{t11}{t18}{t19}</T0>;
    $[105] = T0;
    $[106] = t10;
    $[107] = t11;
    $[108] = t18;
    $[109] = t19;
    $[110] = t5;
    $[111] = t6;
    $[112] = t7;
    $[113] = t8;
    $[114] = t9;
    $[115] = t20;
  } else {
    t20 = $[115];
  }
  let t21;
  if ($[116] !== T1 || $[117] !== t12 || $[118] !== t13 || $[119] !== t14 || $[120] !== t20) {
    t21 = <T1 gap={t12}>{t13}{t14}{t20}</T1>;
    $[116] = T1;
    $[117] = t12;
    $[118] = t13;
    $[119] = t14;
    $[120] = t20;
    $[121] = t21;
  } else {
    t21 = $[121];
  }
  let t22;
  if ($[122] !== T2 || $[123] !== t15 || $[124] !== t16 || $[125] !== t17 || $[126] !== t21) {
    t22 = <T2 size={t15} variant={t16} onClick={t17}>{t21}</T2>;
    $[122] = T2;
    $[123] = t15;
    $[124] = t16;
    $[125] = t17;
    $[126] = t21;
    $[127] = t22;
  } else {
    t22 = $[127];
  }
  return t22;
};
function _temp(event) {
  return event.stopPropagation();
}